'use strict';

DoohApps
.directive('required', ['$timeout', function ($timeout) {
    return {

        restrict: 'A',
        link: function (scope, elem, attrs) {            
            var blacklistedIDs = ['userEmailAdress', 'userPasswordInput'];
            var inputFieldID = elem[0].id;
            if (inputFieldID.length != 0 && blacklistedIDs.indexOf(inputFieldID) < 0) {
                var label = $('label[for="' + inputFieldID + '"]');
                if (label != undefined && label.length != 0) {
                    var labelText = label[0].innerText;
                    label.html(labelText + '*');
                }
            }                              
        }
    }
}]);